function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null);

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Capa_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      "enableBackground": "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, props), React.createElement("rect", {
    y: 85.333,
    style: {
      "fill": "#F0F0F0"
    },
    width: 512,
    height: 341.337
  }), React.createElement("polygon", {
    style: {
      "fill": "#D80027"
    },
    points: "288,85.33 224,85.33 224,223.996 0,223.996 0,287.996 224,287.996 224,426.662 288,426.662  288,287.996 512,287.996 512,223.996 288,223.996 "
  }), React.createElement("g", null, React.createElement("polygon", {
    style: {
      "fill": "#0052B4"
    },
    points: "393.785,315.358 512,381.034 512,315.358 \t"
  }), React.createElement("polygon", {
    style: {
      "fill": "#0052B4"
    },
    points: "311.652,315.358 512,426.662 512,395.188 368.307,315.358 \t"
  }), React.createElement("polygon", {
    style: {
      "fill": "#0052B4"
    },
    points: "458.634,426.662 311.652,344.998 311.652,426.662 \t"
  })), React.createElement("polygon", {
    style: {
      "fill": "#F0F0F0"
    },
    points: "311.652,315.358 512,426.662 512,395.188 368.307,315.358 "
  }), React.createElement("polygon", {
    style: {
      "fill": "#D80027"
    },
    points: "311.652,315.358 512,426.662 512,395.188 368.307,315.358 "
  }), React.createElement("g", null, React.createElement("polygon", {
    style: {
      "fill": "#0052B4"
    },
    points: "90.341,315.356 0,365.546 0,315.356 \t"
  }), React.createElement("polygon", {
    style: {
      "fill": "#0052B4"
    },
    points: "200.348,329.51 200.348,426.661 25.491,426.661 \t"
  })), React.createElement("polygon", {
    style: {
      "fill": "#D80027"
    },
    points: "143.693,315.358 0,395.188 0,426.662 0,426.662 200.348,315.358 "
  }), React.createElement("g", null, React.createElement("polygon", {
    style: {
      "fill": "#0052B4"
    },
    points: "118.215,196.634 0,130.958 0,196.634 \t"
  }), React.createElement("polygon", {
    style: {
      "fill": "#0052B4"
    },
    points: "200.348,196.634 0,85.33 0,116.804 143.693,196.634 \t"
  }), React.createElement("polygon", {
    style: {
      "fill": "#0052B4"
    },
    points: "53.366,85.33 200.348,166.994 200.348,85.33 \t"
  })), React.createElement("polygon", {
    style: {
      "fill": "#F0F0F0"
    },
    points: "200.348,196.634 0,85.33 0,116.804 143.693,196.634 "
  }), React.createElement("polygon", {
    style: {
      "fill": "#D80027"
    },
    points: "200.348,196.634 0,85.33 0,116.804 143.693,196.634 "
  }), React.createElement("g", null, React.createElement("polygon", {
    style: {
      "fill": "#0052B4"
    },
    points: "421.659,196.636 512,146.446 512,196.636 \t"
  }), React.createElement("polygon", {
    style: {
      "fill": "#0052B4"
    },
    points: "311.652,182.482 311.652,85.331 486.509,85.331 \t"
  })), React.createElement("polygon", {
    style: {
      "fill": "#D80027"
    },
    points: "368.307,196.634 512,116.804 512,85.33 512,85.33 311.652,196.634 "
  }), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
};

export default __webpack_public_path__ + "static/media/united-kingdom.386cc387.svg";
export { SvgComponent as ReactComponent };